// date + number helpers. "today" is always the user's LOCAL day.

export const todayStr = (d = new Date()) => {
  const z = new Date(d.getTime() - d.getTimezoneOffset() * 60000)
  return z.toISOString().slice(0, 10)
}

export const shiftDay = (dateStr, delta) => {
  const [y, m, dd] = dateStr.split('-').map(Number)
  const d = new Date(Date.UTC(y, m - 1, dd))
  d.setUTCDate(d.getUTCDate() + delta)
  return d.toISOString().slice(0, 10)
}

export const prettyDate = dateStr => {
  const t = todayStr()
  if (dateStr === t) return 'Today'
  if (dateStr === shiftDay(t, -1)) return 'Yesterday'
  if (dateStr === shiftDay(t, 1)) return 'Tomorrow'
  const [y, m, dd] = dateStr.split('-').map(Number)
  const d = new Date(Date.UTC(y, m - 1, dd))
  return d.toLocaleDateString(undefined, {weekday: 'short', month: 'short', day: 'numeric', timeZone: 'UTC'})
}

// the Sun→Sat week that contains dateStr, as [{date, dow, dom}]
export const weekOf = dateStr => {
  const [y, m, dd] = dateStr.split('-').map(Number)
  const d = new Date(Date.UTC(y, m - 1, dd))
  const sunday = new Date(d)
  sunday.setUTCDate(d.getUTCDate() - d.getUTCDay())
  const LETTERS = ['S', 'M', 'T', 'W', 'T', 'F', 'S']
  const out = []
  for (let i = 0; i < 7; i++) {
    const x = new Date(sunday)
    x.setUTCDate(sunday.getUTCDate() + i)
    out.push({date: x.toISOString().slice(0, 10), dow: LETTERS[i], dom: x.getUTCDate()})
  }
  return out
}

// current local time as HH:MM (24h)
export const nowTime = () => {
  const d = new Date()
  return String(d.getHours()).padStart(2, '0') + ':' + String(d.getMinutes()).padStart(2, '0')
}

// HH:MM (24h) → "7:05 AM"
export const prettyTime = hhmm => {
  if (!hhmm || !/^\d{1,2}:\d{2}$/.test(hhmm)) return ''
  let [h, m] = hhmm.split(':').map(Number)
  const ap = h >= 12 ? 'PM' : 'AM'
  h = h % 12 || 12
  return h + ':' + String(m).padStart(2, '0') + ' ' + ap
}

export const fmt = n => Math.round(n || 0).toLocaleString()

export const MACROS = [
  {key: 'protein', label: 'Protein', color: 'var(--protein)'},
  {key: 'carbs', label: 'Carbs', color: 'var(--carbs)'},
  {key: 'fat', label: 'Fat', color: 'var(--fat)'},
]

// read a File, downscale to <= maxpx on the long edge, return a JPEG data URL
export const fileToDataUrl = (file, maxpx = 1280, quality = 0.82) =>
  new Promise((resolve, reject) => {
    const img = new Image()
    const url = URL.createObjectURL(file)
    img.onload = () => {
      URL.revokeObjectURL(url)
      let {width, height} = img
      const scale = Math.min(1, maxpx / Math.max(width, height))
      width = Math.round(width * scale)
      height = Math.round(height * scale)
      const canvas = document.createElement('canvas')
      canvas.width = width
      canvas.height = height
      canvas.getContext('2d').drawImage(img, 0, 0, width, height)
      resolve(canvas.toDataURL('image/jpeg', quality))
    }
    img.onerror = () => {
      URL.revokeObjectURL(url)
      reject(new Error('could not read image'))
    }
    img.src = url
  })
